import { Link as ChakraLink, LinkProps } from '@chakra-ui/react';
import { faExternalLink } from '@fortawesome/pro-regular-svg-icons';
import { Icon } from '../Icon';

interface IProps extends LinkProps {}

export const Link = (props: IProps) => {
  const { children, href, isExternal = true } = props;

  return (
    <ChakraLink href={href} isExternal={isExternal} rel={isExternal ? 'noopener noreferrer' : null}>
      {children}

      {isExternal ? <Icon icon={faExternalLink} iconProps={{ fixedWidth: true, size: 'xs' }} mx={1} /> : null}
    </ChakraLink>
  );
};
